import React, { useCallback, useEffect, useMemo } from 'react';
import classNames                                 from 'classnames';
import { useParams }                              from 'react-router-dom';

import ConsultationBlock    from '../../../components/consultationBlock';
import Meta                 from '../../../components/meta';
import Notfound             from '../../notfound/components/Notfound';
import PageHeader           from '../../../components/pageHeader';
import Preloader            from '../../../components/containers/preloader';
import SitemapItem          from './components/SitemapItem';
import { sitemapConstants } from './constants';
import { useCatalog }       from '../../../providers/catalog';
import { useCommon }        from '../../../providers/common';
import { useNavigation }    from '../../../providers/navigation';

function Sitemap() {
  const {
          resetFilter,
          getCatalogItems,
        }        = useCatalog();
  const { menu } = useNavigation();
  const {
          loading,
          pages,
        }        = useCommon();
  const params   = useParams();

  const page = useMemo(() => pages.find(({ urlKey }) => urlKey === params.page), [pages, params.page]);

  const {
          headImage,
          label,
          meta,
        } = page;
  const {
          left,
          right,
        } = menu;

  const headerProps = useMemo(() => (
    {
      transparent: false,
    }), []);

  const handleClickItem = useCallback((item) => {
    if (sitemapConstants.NEED_RESET.includes(item.url)) {
      resetFilter();
      getCatalogItems(`/${item.url}`);
    }
  }, [resetFilter, getCatalogItems]);

  if (typeof headImage === 'string') {
    headerProps.transparent = true;
    headerProps.bg          = headImage;
  }

  useEffect(() => {
    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
  }, []);

  if (!page) {
    return (
      <Notfound />
    );
  }

  return (
    <>
      <div className={classNames('page-content', 'sitemap_wrapper')}>
        <Meta {...meta} />
        {typeof label === 'string' && label.length > 0 && (
          <PageHeader noBorder {...headerProps}>{label}</PageHeader>
        )}
        <main className={'sitemap'}>
          <article>
            {left.map((leftSubItem, leftSubItemIndex) => (
              <section>
                <h3>{leftSubItem.label}</h3>
                <SitemapItem
                  key={leftSubItemIndex}
                  item={leftSubItem}
                  onClick={handleClickItem}
                />
              </section>
            ))}
            {right.map((rightSubItem, rightSubItemIndex) => (
              <section>
                <h3>{rightSubItem.label}</h3>
                <SitemapItem
                  key={rightSubItemIndex}
                  item={rightSubItem}
                  onClick={handleClickItem}
                />
              </section>
            ))}
          </article>
          <ConsultationBlock />
        </main>
      </div>
      {loading && (
        <Preloader />
      )}
    </>
  );
}

export default Sitemap;